export default "__VITE_ASSET__BF3$qIEB__"